import styled from 'styled-components/macro';

export const Container = styled.div`
  width: 100%;
`;
